import { render, staticRenderFns } from "./oaFromBox.vue?vue&type=template&id=4486fafb&scoped=true"
import script from "./oaFromBox.vue?vue&type=script&lang=js"
export * from "./oaFromBox.vue?vue&type=script&lang=js"
import style0 from "./oaFromBox.vue?vue&type=style&index=0&id=4486fafb&lang=scss&scoped=true"
import style1 from "./oaFromBox.vue?vue&type=style&index=1&id=4486fafb&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4486fafb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4486fafb')) {
      api.createRecord('4486fafb', component.options)
    } else {
      api.reload('4486fafb', component.options)
    }
    module.hot.accept("./oaFromBox.vue?vue&type=template&id=4486fafb&scoped=true", function () {
      api.rerender('4486fafb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/oaFromBox.vue"
export default component.exports